import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { CustactService, WorkingOrderSelectionItem } from '@app/services/custact.service';

@Component({
    selector: 'tt-select-working-order',
    templateUrl: './select-working-order.component.html',
    styleUrls: ['./select-working-order.component.css'],
    standalone: false
})
export class SelectWorkingOrderComponent implements OnInit {
    public items: WorkingOrderSelectionItem[] = [];

    public filterText = '';

    public error = '';

    constructor(
        private custact: CustactService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        try {
            this.items = await this.custact.listWorkingOrders({
                cust_name: 'ALL',
                cust_no: '0',
                project_keyno: '0',
                ok: '0'
            });
        } catch (error) { this.showError(error); }
    }

    public get filteredItems(): WorkingOrderSelectionItem[] {
        if (this.filterText === '') return this.items;

        const words = this.filterText.toLowerCase().split(' ');

        return this.items.filter((item, index, items) => items.indexOf(item) === index && (
            item.item_filtervalue === undefined || item.item_id === '0' || item.item_id === '-1' ||
            words.every(word => item.item_filtervalue!.toLowerCase().includes(word))
        ));
    }

    public select(item: WorkingOrderSelectionItem): void {
        if (item.item_id === '') return;

        // The legacy callback starts the save and returns immediately, without waiting for its response.
        void this.custact.selectWorkingOrder({
            custact_no: item.item_id,
            webpagename: String(this.navigator?.params['webpagename'] ?? '')
        }).catch(error => this.showError(error));

        this.navigator?.back();
    }

    private showError(error: unknown): void {
        this.error = error instanceof Error ? error.message : String(error);
    }
}
